export const ROUTES = {
  ORGANISATIONS: '/organisations',
  REGIONS: '/regions',
  PROBLEMATIC_PHARMACIES: '/problematic-pharmacies',
  SURGERIES: '/surgeries',
  WHITELABELS: '/whitelabels',
  ECOMMERCE: '/ecommerce',
  SERVICES: '/services',
  BRANCHES: '/branches',
  DASHBOARD: '/dashboard',
  ANNOUNCEMENTS: '/announcements',
  CAMPAIGNS: '/campaigns',
  QUESTIONNAIRES: '/questionnaires',
  CLINICS: '/clinics',
};
